var option_webview_default = {
  "option": "OM08-",
  "user_choice": "BmFhB",
  "check": "NVtGi",
  "image": "NleEe",
  "input": "Ob0hm",
  "title": "jEbLd",
  "centered": "gbcV4",
  "with_result": "AMqPI",
  "list": "hbzcD",
  "with_image": "xVWu6",
  "progress": "QuEOI",
  "progress_value": "aZivf",
  "label": "_20yFa",
  "cta": "uVJbc",
  "adornment_icon": "BDC1I",
  "remove": "xuoGg",
  "removeButton": "MiFZ4",
  "removeButtonIcon": "lobEq",
  "overlay": "_10W38",
  "shown": "PIl4i",
  "dark": "_7lJhD",
  "spinner": "WnV6C",
  "spin": "XqFhM",
  "grid": "o3ZXt"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
